<template>
  <cargo-advance-select
    :disabled="disabled"
    :select-type="selectTypeNames.basic_data_Packing"
    :show-custom-label-in-option="true"
    :custom-label="packingLabel"
    filterable
    :default-value="defaultValue"
    :placeholder="placeholder||undefined"
    style="width: 100%"
    @clear="$emit('clear')"
    @parentCallBack="p=>{$emit('change',p)}"
    @blur="$emit('blur')"
    @focus="$emit('focus')"
  />
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'CargoPackingSelect',
  components: { cargoAdvanceSelect },
  props: {
    disabled: { type: Boolean, default: false },
    defaultValue: { type: [String, Number, Boolean], default: '' },
    placeholder: { type: String, default: '' }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES
    }
  },
  methods: {
    packingLabel(item) {
      if (item) {
        return item.chineseName + '[' + item.name + ']'
      }
      return ''
    }
  }
}
</script>
